"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigurationCacheEntryExtractor = exports.GradleHomeEntryExtractor = void 0;
const path_1 = __importDefault(require("path"));
const fs_1 = __importDefault(require("fs"));
const core = __importStar(require("@actions/core"));
const glob = __importStar(require("@actions/glob"));
const semver = __importStar(require("semver"));
const params = __importStar(require("./input-params"));
const cache_base_1 = require("./cache-base");
const cache_utils_1 = require("./cache-utils");
const build_results_1 = require("./build-results");
const SKIP_RESTORE_VAR = 'GRADLE_BUILD_ACTION_SKIP_RESTORE';
class ExtractedCacheEntry {
    constructor(artifactType, pattern, cacheKey) {
        this.artifactType = artifactType;
        this.pattern = pattern;
        this.cacheKey = cacheKey;
    }
}
class ExtractedCacheEntryMetadata {
    constructor() {
        this.entries = [];
    }
}
class ExtractedCacheEntryDefinition {
    constructor(artifactType, pattern, bundle) {
        this.uniqueFileNames = true;
        this.artifactType = artifactType;
        this.pattern = pattern;
        this.bundle = bundle;
    }
    withNonUniqueFileNames() {
        this.uniqueFileNames = false;
        return this;
    }
    notCacheableBecause(reason) {
        this.notCacheableReason = reason;
        return this;
    }
}
class AbstractEntryExtractor {
    constructor(gradleUserHome, extractorName) {
        this.gradleUserHome = gradleUserHome;
        this.extractorName = extractorName;
    }
    restore(listener) {
        return __awaiter(this, void 0, void 0, function* () {
            const previouslyExtractedCacheEntries = this.loadExtractedCacheEntries();
            const processes = [];
            for (const cacheEntry of previouslyExtractedCacheEntries) {
                const artifactType = cacheEntry.artifactType;
                const entryListener = listener.entry(cacheEntry.pattern);
                const skipRestore = process.env[SKIP_RESTORE_VAR] || '';
                if (skipRestore.includes(artifactType)) {
                    core.info(`Not restoring extracted cache entry for ${artifactType}`);
                    entryListener.markRequested('SKIP_RESTORE');
                }
                else {
                    processes.push(this.awaitForDebugging(this.restoreExtractedCacheEntry(artifactType, cacheEntry.cacheKey, cacheEntry.pattern, entryListener)));
                }
            }
            this.saveMetadataForCacheResults(yield Promise.all(processes));
        });
    }
    restoreExtractedCacheEntry(artifactType, cacheKey, pattern, listener) {
        return __awaiter(this, void 0, void 0, function* () {
            const restoredEntry = yield (0, cache_utils_1.restoreCache)([pattern], cacheKey, [], listener);
            if (restoredEntry) {
                core.info(`Restored ${artifactType} with key ${cacheKey} to ${pattern}`);
                return new ExtractedCacheEntry(artifactType, pattern, cacheKey);
            }
            else {
                core.info(`Did not restore ${artifactType} with key ${cacheKey} to ${pattern}`);
                return new ExtractedCacheEntry(artifactType, pattern, undefined);
            }
        });
    }
    extract(listener) {
        return __awaiter(this, void 0, void 0, function* () {
            const cacheEntryDefinitions = this.getExtractedCacheEntryDefinitions();
            (0, cache_utils_1.cacheDebug)(`Extracting cache entries for ${this.extractorName}: ${JSON.stringify(cacheEntryDefinitions, null, 2)}`);
            const previouslyRestoredEntries = this.loadExtractedCacheEntries();
            const cacheActions = [];
            for (const cacheEntryDefinition of cacheEntryDefinitions) {
                const artifactType = cacheEntryDefinition.artifactType;
                const pattern = cacheEntryDefinition.pattern;
                if (cacheEntryDefinition.notCacheableReason) {
                    listener.entry(pattern).markNotSaved(cacheEntryDefinition.notCacheableReason);
                    continue;
                }
                const globber = yield glob.create(pattern, {
                    implicitDescendants: false
                });
                const matchingFiles = yield globber.glob();
                if (matchingFiles.length === 0) {
                    (0, cache_utils_1.cacheDebug)(`No files found to cache for ${artifactType}`);
                    continue;
                }
                if (cacheEntryDefinition.bundle) {
                    cacheActions.push(this.awaitForDebugging(this.saveExtractedCacheEntry(matchingFiles, artifactType, pattern, cacheEntryDefinition.uniqueFileNames, previouslyRestoredEntries, listener.entry(pattern))));
                }
                else {
                    for (const cacheFile of matchingFiles) {
                        cacheActions.push(this.awaitForDebugging(this.saveExtractedCacheEntry([cacheFile], artifactType, cacheFile, cacheEntryDefinition.uniqueFileNames, previouslyRestoredEntries, listener.entry(cacheFile))));
                    }
                }
            }
            this.saveMetadataForCacheResults(yield Promise.all(cacheActions));
        });
    }
    saveExtractedCacheEntry(matchingFiles, artifactType, pattern, uniqueFileNames, previouslyRestoredEntries, entryListener) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const cacheKey = uniqueFileNames
                ? this.createCacheKeyFromFileNames(artifactType, matchingFiles)
                : yield this.createCacheKeyFromFileContents(artifactType, pattern);
            const previouslyRestoredKey = (_a = previouslyRestoredEntries.find(x => x.artifactType === artifactType && x.pattern === pattern)) === null || _a === void 0 ? void 0 : _a.cacheKey;
            if (previouslyRestoredKey === cacheKey) {
                (0, cache_utils_1.cacheDebug)(`No change to previously restored ${artifactType}. Not saving.`);
                entryListener.markNotSaved('contents unchanged');
            }
            else {
                core.info(`Caching ${artifactType} with path '${pattern}' and cache key: ${cacheKey}`);
                yield (0, cache_utils_1.saveCache)([pattern], cacheKey, entryListener);
            }
            for (const file of matchingFiles) {
                (0, cache_utils_1.tryDelete)(file);
            }
            return new ExtractedCacheEntry(artifactType, pattern, cacheKey);
        });
    }
    createCacheKeyFromFileNames(artifactType, files) {
        const cacheKeyPrefix = (0, cache_utils_1.getCacheKeyPrefix)();
        const relativeFiles = files.map(x => path_1.default.relative(this.gradleUserHome, x));
        const key = (0, cache_utils_1.hashFileNames)(relativeFiles);
        (0, cache_utils_1.cacheDebug)(`Generating cache key for ${artifactType} from file names: ${relativeFiles}`);
        return `${cacheKeyPrefix}${artifactType}-${key}`;
    }
    createCacheKeyFromFileContents(artifactType, pattern) {
        return __awaiter(this, void 0, void 0, function* () {
            const cacheKeyPrefix = (0, cache_utils_1.getCacheKeyPrefix)();
            const key = yield glob.hashFiles(pattern);
            (0, cache_utils_1.cacheDebug)(`Generating cache key for ${artifactType} from files matching: ${pattern}`);
            return `${cacheKeyPrefix}${artifactType}-${key}`;
        });
    }
    awaitForDebugging(p) {
        return __awaiter(this, void 0, void 0, function* () {
            if (params.isCacheDebuggingEnabled()) {
                yield p;
            }
            return p;
        });
    }
    loadExtractedCacheEntries() {
        const cacheMetadataFile = this.getCacheMetadataFile();
        if (!fs_1.default.existsSync(cacheMetadataFile)) {
            return [];
        }
        const filedata = fs_1.default.readFileSync(cacheMetadataFile, 'utf-8');
        (0, cache_utils_1.cacheDebug)(`Loaded cache metadata for ${this.extractorName}: ${filedata}`);
        const extractedCacheEntryMetadata = JSON.parse(filedata);
        return extractedCacheEntryMetadata.entries;
    }
    saveMetadataForCacheResults(results) {
        const extractedCacheEntryMetadata = new ExtractedCacheEntryMetadata();
        extractedCacheEntryMetadata.entries = results.filter(x => x.cacheKey !== undefined);
        const filedata = JSON.stringify(extractedCacheEntryMetadata);
        (0, cache_utils_1.cacheDebug)(`Saving cache metadata for ${this.extractorName}: ${filedata}`);
        fs_1.default.writeFileSync(this.getCacheMetadataFile(), filedata, 'utf-8');
    }
    getCacheMetadataFile() {
        const actionMetadataDirectory = path_1.default.resolve(this.gradleUserHome, cache_base_1.META_FILE_DIR);
        fs_1.default.mkdirSync(actionMetadataDirectory, { recursive: true });
        return path_1.default.resolve(actionMetadataDirectory, `${this.extractorName}-entry-metadata.json`);
    }
}
class GradleHomeEntryExtractor extends AbstractEntryExtractor {
    constructor(gradleUserHome) {
        super(gradleUserHome, 'gradle-home');
    }
    extract(listener) {
        const _super = Object.create(null, {
            extract: { get: () => super.extract }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteWrapperZips();
            return _super.extract.call(this, listener);
        });
    }
    deleteWrapperZips() {
        return __awaiter(this, void 0, void 0, function* () {
            const wrapperZips = path_1.default.resolve(this.gradleUserHome, 'wrapper/dists/*/*/*.zip');
            const globber = yield glob.create(wrapperZips, {
                implicitDescendants: false
            });
            for (const wrapperZip of yield globber.glob()) {
                (0, cache_utils_1.cacheDebug)(`Deleting wrapper zip: ${wrapperZip}`);
                yield (0, cache_utils_1.tryDelete)(wrapperZip);
            }
        });
    }
    getExtractedCacheEntryDefinitions() {
        const entryDefinition = (artifactType, patterns, bundle) => {
            const resolvedPatterns = patterns
                .map(x => {
                const isDir = x.endsWith('/');
                const resolved = path_1.default.resolve(this.gradleUserHome, x);
                return isDir ? `${resolved}/` : resolved;
            })
                .join('\n');
            return new ExtractedCacheEntryDefinition(artifactType, resolvedPatterns, bundle);
        };
        return [
            entryDefinition('generated-gradle-jars', ['caches/*/generated-gradle-jars/*.jar'], false),
            entryDefinition('wrapper-zips', ['wrapper/dists/*/*/'], false),
            entryDefinition('java-toolchains', ['jdks/*/'], false),
            entryDefinition('dependencies', ['caches/modules-*/files-*/*/*/*/*'], true),
            entryDefinition('instrumented-jars', ['caches/jars-*/*'], true),
            entryDefinition('kotlin-dsl', ['caches/*/kotlin-dsl/*/*'], true)
        ];
    }
}
exports.GradleHomeEntryExtractor = GradleHomeEntryExtractor;
class ConfigurationCacheEntryExtractor extends AbstractEntryExtractor {
    constructor(gradleUserHome) {
        super(gradleUserHome, 'configuration-cache');
    }
    restore(listener) {
        const _super = Object.create(null, {
            restore: { get: () => super.restore }
        });
        return __awaiter(this, void 0, void 0, function* () {
            if (!listener.fullyRestored) {
                this.markNotRestored(listener, 'Gradle User Home was not fully restored');
                return;
            }
            if (!params.getCacheEncryptionKey()) {
                this.markNotRestored(listener, 'Encryption Key was not provided');
                return;
            }
            return yield _super.restore.call(this, listener);
        });
    }
    markNotRestored(listener, reason) {
        const cacheEntries = this.loadExtractedCacheEntries();
        if (cacheEntries.length > 0) {
            core.info(`Not restoring configuration-cache state, as ${reason}`);
            for (const cacheEntry of cacheEntries) {
                listener.entry(cacheEntry.pattern).markNotRestored(reason);
            }
            this.saveMetadataForCacheResults([]);
        }
    }
    extract(listener) {
        const _super = Object.create(null, {
            extract: { get: () => super.extract }
        });
        return __awaiter(this, void 0, void 0, function* () {
            if (!params.getCacheEncryptionKey()) {
                const cacheEntryDefinitions = this.getExtractedCacheEntryDefinitions();
                if (cacheEntryDefinitions.length > 0) {
                    core.info('Not saving configuration-cache state, as no encryption key was provided');
                    for (const cacheEntry of cacheEntryDefinitions) {
                        listener.entry(cacheEntry.pattern).markNotSaved('No encryption key provided');
                    }
                }
                return;
            }
            yield _super.extract.call(this, listener);
        });
    }
    getExtractedCacheEntryDefinitions() {
        const groupedResults = this.getConfigCacheDirectoriesWithAssociatedBuildResults();
        return Object.entries(groupedResults).map(([configCachePath, pathResults]) => {
            const definition = new ExtractedCacheEntryDefinition('configuration-cache', configCachePath, true).withNonUniqueFileNames();
            if (pathResults.find(result => {
                const gradleVersion = semver.coerce(result.gradleVersion);
                return gradleVersion && semver.lt(gradleVersion, '8.6.0');
            })) {
                core.info(`Not saving config-cache data for ${configCachePath}. Configuration cache data is only saved for Gradle 8.6+`);
                definition.notCacheableBecause('Configuration cache data only saved for Gradle 8.6+');
            }
            return definition;
        });
    }
    getConfigCacheDirectoriesWithAssociatedBuildResults() {
        return (0, build_results_1.loadBuildResults)().reduce((acc, buildResult) => {
            const configCachePath = path_1.default.resolve(buildResult.rootProjectDir, '.gradle/configuration-cache');
            if (!fs_1.default.existsSync(configCachePath)) {
                return acc;
            }
            if (!acc[configCachePath]) {
                acc[configCachePath] = [];
            }
            acc[configCachePath].push(buildResult);
            return acc;
        }, {});
    }
}
exports.ConfigurationCacheEntryExtractor = ConfigurationCacheEntryExtractor;
